package tta.destinigo.talktoastro.feature_call_consultation.persentation.voip_call_page

import tta.destinigo.talktoastro.feature_call_consultation.data.response.voip_agora_token.VoipAgoraTokenData

sealed class VoiPCallState {
    data class OnLoading(val isLoading: Boolean) : VoiPCallState()
    data class OnError(val msg: String) : VoiPCallState()
    data class OnSuccess(val data: VoipAgoraTokenData) : VoiPCallState()
    data class OnMicPermissionChanged(val isGranted: Boolean) : VoiPCallState()
}